import {
  Avatar,
  Box,
  Button,
  ButtonGroup,
  Card,
  CardContent,
  CircularProgress,
  colors,
  Grid,
  IconButton,
  Link,
  Popover,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";
import ConstructionIcon from "@mui/icons-material/Construction";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import {
  useGetDealerDmsSetupStatsQuery,
  useGetOrderAnalyticsMutation,
  useGetBestSellingProductsMutation,
} from "../../redux/reducer/features/Dashboard/DashboardSlice";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../redux/reducer/rootReducer";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import dayjs, { Dayjs } from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { RecentOrders } from "./Compenents/RecentOrders";
import { RecentLeads } from "./Compenents/RecentLeads";
import { TotalOrders } from "./Compenents/TotalOrders";
import { TotalSales } from "./Compenents/TotalSales";
import { AverageOrderValue } from "./Compenents/AverageOrderValue";
import { TopSellingProducts } from "./Compenents/TopSellingProducts";
import {
  DragDropContext,
  Draggable,
  Droppable,
  DropResult,
} from "react-beautiful-dnd";
import { AppGridId } from "../../models/app/AppGridModels";
import { setPositions } from "../../redux/reducer/features/Dashboard/widgetSlice";
import { useAddAppGridSettingMutation } from "../../redux/reducer/features/App/AppGridSlice";
import { setDashboardFilterDate } from "../../redux/reducer/features/Auth/authSlice";
import { AppHealth } from "./Compenents/AppHealth";
import utc from "dayjs/plugin/utc";
export type Widgets = {
  id: number;
  name: string;
  component: React.ComponentType<any> | any;
  props?: any;
};

interface DealerDashboardStats {
  totalWholegoods: number;
  syncedWholegoods: number;
  totalParts: number;
  syncedParts: number;
  totalOrders: number;
}
interface ShopifyProduct {
  productAggregateId: number;
  title: string;
  model: string;
  shopifyProductLink: string;
  totalQuantity: number;
}

dayjs.extend(utc);

export const DealerDashboard: React.FunctionComponent = () => {
  const { dmsSetup } = useSelector((state: AppState) => state.authReducer);
  const [xAxisData, setXAxisData] = useState<string[] | Date[] | number[]>([]);
  const [yAxisOrderData, setYAxisOrderData] = useState<any[]>([]);
  const [yAxisSalesData, setYAxisSalesData] = useState<any[]>([]);
  const [yAxisOrderAvgData, setYAxisOrderAvgData] = useState<any[]>([]);
  const [totalOrdersCount, setTotalOrdersCount] = useState<number>(0);
  const [totalOrdersSale, setTotalOrdersSale] = useState<number>(0);
  const [totalAvgOrderValue, setTotalAvgOrderValue] = useState<number>(0);
  const [dateDifference, setDateDifference] = useState<number>(0);
  const [selectedPresetFilter, setSelectedPresetFilter] = useState(
    dmsSetup?.dashboardPresetFilter ?? "1M"
  );
  const dispatch = useDispatch();
  const { dmsDealerId } = useSelector((state: AppState) => state.authReducer);
  const { userId } = useSelector((state: AppState) => state.authReducer);
  const positions = useSelector(
    (state: AppState) => state.widgetReducer.positions
  );
  const [saveSettingMutation, settingMutationResult] =
    useAddAppGridSettingMutation();
  const [bestSellingProducts, setBestSellingProducts] = useState<
    ShopifyProduct[]
  >([]);
  const [stats, setStats] = useState<DealerDashboardStats>({
    totalWholegoods: 0,
    syncedWholegoods: 0,
    totalParts: 0,
    syncedParts: 0,
    totalOrders: 0,
  });
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const [fromDate, setFromDate] = useState<Dayjs | null>(
    dmsSetup?.dashboardFilterFromDate
      ? dayjs(dmsSetup?.dashboardFilterFromDate)
      : dayjs().subtract(1, "month")
  );
  const [toDate, setToDate] = useState<Dayjs | null>(
    dayjs(dmsSetup?.dashboardFilterToDate) ?? dayjs()
  );

  const [tempFromDate, setTempFromDate] = useState<Dayjs>(
    dayjs(dmsSetup?.dashboardFilterFromDate) ?? dayjs().subtract(1, "month")
  );
  const [tempToDate, setTempToDate] = useState<Dayjs>(
    dayjs(dmsSetup?.dashboardFilterToDate) ?? dayjs()
  );

  const [getOrderAnalyticsMutation, getOrderAnalyticsMutationResult] =
    useGetOrderAnalyticsMutation();
  const [
    getBestSellingAnalyticsMutation,
    getBestSellingAnalyticsMutationResult,
  ] = useGetBestSellingProductsMutation();
  const { data, isLoading, isSuccess, status } = useGetDealerDmsSetupStatsQuery(
    { dealerId: dmsDealerId?.toString() ?? "" },
    { skip: dmsSetup?.id === undefined ? true : false }
  );

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleGetShopifyURL = (URL: string): string => {
    return URL.replace("https://", "").replace(".myshopify.com", "");
  };
  const handleGetBestSellingAnalytics = (from: string, to: string) => {
    getBestSellingAnalyticsMutation({
      request: { fromDate: from, toDate: to },
    }).then((res: any) => {
      if (res && res.data) {
        if (res.data.status === 200) {
          setBestSellingProducts(res.data.entityList);
        } else if (res.data.status === 404) {
          setBestSellingProducts([]);
        }
      }
    });
  };
  const handleGetOrderAnalytics = (from: string, to: string) => {
    getOrderAnalyticsMutation({
      request: { fromDate: from, toDate: to },
    }).then((res: any) => {
      if (res && res.data) {
        if (res.data.status === 200) {
          let orders = res.data.entityList;
          let totalSale = orders.reduce(
            (total: number, order: any) => total + order.amount,
            0
          );
          setTotalOrdersCount(orders.length);
          setTotalOrdersSale(totalSale);
          setTotalAvgOrderValue(totalSale / orders.length);
          const fromDayjs = dayjs(from);
          const toDayjs = dayjs(to);
          const dateDifference = toDayjs.diff(fromDayjs, "day");
          const hourDifference = toDayjs.diff(fromDayjs, "hour");
          let dateRange: string[] = [];
          let orderCounts = [];
          let orderAmounts = [];
          let orderAverageAmounts = [];

          setDateDifference(dateDifference);
          if (hourDifference <= 1 && dateDifference < 1) {
            // Use 10-minute intervals for time ranges within 1 hour (same day)
            dateRange = generateDateChunks(from, to, "minutes", 10, "datetime");
          } else if (hourDifference <= 24 && dateDifference < 1) {
            console.log(hourDifference);
            // Use 3-hour intervals for time ranges within 24 hours (same day).
            dateRange = generateDateChunks(from, to, "hours", 3, "datetime");
          } else if (dateDifference <= 20) {
            // Use daily intervals for time ranges up to 20 days.
            dateRange = generateDateChunks(from, to, "days", 1, "date");
          } else if (dateDifference <= 60) {
            // Use weekly intervals for time ranges between 21 and 60 days.
            dateRange = generateDateChunks(from, to, "weeks", 1, "date");
          } else if (dateDifference < 300) {
            // Use monthly intervals for time ranges between 2 and 10 months.
            dateRange = generateDateChunks(from, to, "months", 1, "date");
          } else {
            // Use quarterly (3-month) intervals for time ranges over 10 months.
            dateRange = generateDateChunks(from, to, "months", 3, "date");
          }
          orderCounts = countOrdersInDateRange(orders, dateRange);
          orderAmounts = sumOrderAmountsInDateRange(orders, dateRange);
          orderAverageAmounts = averageOrderAmountsInDateRange(
            orders,
            dateRange
          );

          setXAxisData(dateRange);
          setYAxisOrderData(orderCounts);
          setYAxisSalesData(orderAmounts);
          setYAxisOrderAvgData(orderAverageAmounts);
        } else if (res.data.status === 404) {
          setTotalOrdersCount(0);
          setTotalOrdersSale(0.0);
          setTotalAvgOrderValue(0.0);
          setXAxisData([]);
          setYAxisOrderData([]);
          setYAxisSalesData([]);
          setYAxisOrderAvgData([]);
        }
      }
    });
  };

  const syncPresetFilterWithDatePicker = (source: string) => {
    if (source === "applyButton") {
      if (
        fromDate?.format("YYYY-MM-DD HH:mm:ss") ===
          dayjs().subtract(1, "hour").format("YYYY-MM-DD HH:mm:ss") &&
        toDate?.format("YYYY-MM-DD HH:mm:ss") ===
          dayjs().format("YYYY-MM-DD HH:mm:ss")
      ) {
        setSelectedPresetFilter("1H");
      } else if (
        fromDate?.format("YYYY-MM-DD") === dayjs().format("YYYY-MM-DD") &&
        toDate?.format("YYYY-MM-DD") === dayjs().format("YYYY-MM-DD")
      ) {
        setSelectedPresetFilter("1D");
      } else if (
        fromDate?.format("YYYY-MM-DD") ===
          dayjs().subtract(7, "day").format("YYYY-MM-DD") &&
        toDate?.format("YYYY-MM-DD") === dayjs().format("YYYY-MM-DD")
      ) {
        setSelectedPresetFilter("7D");
      } else if (
        fromDate?.format("YYYY-MM-DD") ===
          dayjs().subtract(1, "month").format("YYYY-MM-DD") &&
        toDate?.format("YYYY-MM-DD") === dayjs().format("YYYY-MM-DD")
      ) {
        setSelectedPresetFilter("1M");
      } else if (
        fromDate?.format("YYYY-MM-DD") ===
          dayjs().subtract(3, "month").format("YYYY-MM-DD") &&
        toDate?.format("YYYY-MM-DD") === dayjs().format("YYYY-MM-DD")
      ) {
        setSelectedPresetFilter("3M");
      } else if (
        fromDate?.format("YYYY-MM-DD") ===
          dayjs().subtract(1, "year").format("YYYY-MM-DD") &&
        toDate?.format("YYYY-MM-DD") === dayjs().format("YYYY-MM-DD")
      ) {
        setSelectedPresetFilter("1Y");
      } else if (
        fromDate?.format("YYYY-MM-DD") ===
          dayjs().startOf("year").format("YYYY-MM-DD") &&
        toDate?.format("YYYY-MM-DD") === dayjs().format("YYYY-MM-DD")
      ) {
        setSelectedPresetFilter("YTD");
      } else {
        setSelectedPresetFilter("");
      }
    }
  };
  const handleApply = (source: string) => {
    if (fromDate && toDate) {
      syncPresetFilterWithDatePicker(source);
      dispatch(
        setDashboardFilterDate({
          to: toDate,
          from: fromDate,
          presetFilter: selectedPresetFilter,
        })
      );
      const formattedFromDate = fromDate?.utc().format("YYYY-MM-DD HH:mm:ss");
      const formattedToDate = toDate?.utc().format("YYYY-MM-DD HH:mm:ss");
      handleGetOrderAnalytics(formattedFromDate, formattedToDate);
      handleGetBestSellingAnalytics(formattedFromDate, formattedToDate);
    }
    handleClose();
  };
  useEffect(() => {
    if (data && isSuccess) {
      if (data.status === 200) {
        setStats(data.entity);
      }
    }
  }, [data]);

  function onDragEnd(result: DropResult) {
    let dropElements: any = document.querySelectorAll(".widgets-droparea>div");

    dropElements.forEach(function (element: any) {
      element.style.backgroundColor = "inherit";
    });

    const { source, destination } = result;
    if (!destination) return;

    const newPositions = Array.from(positions);
    const [movedItem] = newPositions.splice(source.index, 1);
    newPositions.splice(destination.index, 0, movedItem);
    dispatch(setPositions(newPositions));

    var data = JSON.stringify(newPositions);
    saveSettingMutation({
      data: {
        userId: userId ?? "",
        gridId: AppGridId.Dashboard_Cards,
        setting: data,
      },
    });
  }

  function onDragStart() {
    let dropElements: any = document.querySelectorAll(".widgets-droparea>div");
    dropElements.forEach(function (element: any) {
      element.style.backgroundColor = "#222222";
    });
  }

  const getListStyle = (isDraggingOver: any) => ({
    background: isDraggingOver ? "lightblue" : "",
  });

  const getItemStyle = (isDragging: any, draggableStyle: any) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: "none",

    // change background colour if dragging
    background: isDragging ? colors.lightBlue : "",
    // styles we need to apply on draggables
    ...draggableStyle,
  });

  const WidgetList: Widgets[] = [
    {
      id: 1,
      name: "Total Orders",
      component: TotalOrders,
      props: {
        totalOrdersCount: totalOrdersCount,
        isLoading: getOrderAnalyticsMutationResult.isLoading,
        xAxisData: xAxisData,
        yAxisData: yAxisOrderData,
        dateDifference: dateDifference,
        isCurrency: false,
      },
    },
    {
      id: 2,
      name: "Total Sales",
      component: TotalSales,
      props: {
        totalOrdersSale: totalOrdersSale,
        isLoading: getOrderAnalyticsMutationResult.isLoading,
        xAxisData: xAxisData,
        yAxisData: yAxisSalesData,
        dateDifference: dateDifference,
        isCurrency: true,
      },
    },
    {
      id: 3,
      name: "Average Order Value",
      component: AverageOrderValue,
      props: {
        totalAvgOrderValue: totalAvgOrderValue,
        isLoading: getOrderAnalyticsMutationResult.isLoading,
        xAxisData: xAxisData,
        yAxisData: yAxisOrderAvgData,
        dateDifference: dateDifference,
        isCurrency: true,
      },
    },
    {
      id: 4,
      name: "Top Selling Products",
      component: TopSellingProducts,
      props: {
        isLoading: getBestSellingAnalyticsMutationResult.isLoading,
        dataSet: bestSellingProducts,
      },
    },
  ];

  const getWidgetById = (id: number) =>
    WidgetList.find((widget) => widget.id === id);

  const presetFilters = ["1H", "1D", "7D", "1M", "3M", "1Y", "YTD"];

  const handlePresetFilterChange = (filter: string) => {
    setSelectedPresetFilter(filter);
    switch (filter) {
      case "1H":
        setFromDate(dayjs().subtract(1, "hour"));
        setToDate(dayjs());
        break;
      case "1D":
        setFromDate(dayjs().startOf("day"));
        setToDate(dayjs().endOf("day"));
        break;
      case "7D":
        setFromDate(dayjs().subtract(6, "day").startOf("day"));
        setToDate(dayjs().endOf("day"));
        break;
      case "1M":
        setFromDate(dayjs().subtract(1, "month").startOf("day"));
        setToDate(dayjs().endOf("day"));
        break;
      case "3M":
        setFromDate(dayjs().subtract(3, "month").startOf("day"));
        setToDate(dayjs().endOf("day"));
        break;
      case "1Y":
        setFromDate(dayjs().subtract(1, "year").startOf("day"));
        setToDate(dayjs().endOf("day"));
        break;
      case "YTD":
        setFromDate(dayjs().startOf("year").startOf("day"));
        setToDate(dayjs().endOf("day"));
    }
  };

  useEffect(() => {
    handleApply("presetFilter");
  }, [selectedPresetFilter]);

  useEffect(() => {
    if (dmsSetup?.dashboardFilterFromDate && dmsSetup?.dashboardFilterToDate) {
      setTempFromDate(dayjs(dmsSetup?.dashboardFilterFromDate));
      setTempToDate(dayjs(dmsSetup?.dashboardFilterToDate));
    }
  }, [dmsSetup?.dashboardFilterFromDate, dmsSetup?.dashboardFilterToDate]);

  return (
    <>
      <Grid container spacing={3} display={"flex"} alignItems={"flex-end"}>
        <Grid item md={3} xs={12}>
          <Card sx={{ height: "100%" }}>
            <CardContent>
              <Grid
                container
                spacing={3}
                sx={{ justifyContent: "space-between" }}
              >
                <Grid item>
                  <Typography
                    color="textSecondary"
                    gutterBottom
                    variant="overline"
                  >
                    TOTAL WHOLEGOODS
                  </Typography>
                  <Typography color="textPrimary" variant="h4">
                    {isLoading ? (
                      <CircularProgress size="1.2rem" color="inherit" />
                    ) : (
                      stats.totalWholegoods
                    )}
                  </Typography>
                </Grid>
                <Grid item>
                  <Avatar
                    sx={{
                      backgroundColor: "error.main",
                      height: 56,
                      width: 56,
                    }}
                  >
                    <PrecisionManufacturingIcon />
                  </Avatar>
                </Grid>
              </Grid>
              <Box
                sx={{
                  pt: 2,
                  display: "flex",
                  alignItems: "baseline",
                }}
              >
                <Typography
                  sx={{
                    mr: 1,
                  }}
                  variant="body2"
                >
                  {stats.syncedWholegoods}
                </Typography>
                <Typography color="textSecondary" variant="caption">
                  Synced
                </Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>
        <Grid item md={3} xs={12}>
          <Card>
            <CardContent>
              <Grid
                container
                spacing={3}
                sx={{ justifyContent: "space-between" }}
              >
                <Grid item>
                  <Typography
                    color="textSecondary"
                    gutterBottom
                    variant="overline"
                  >
                    TOTAL PARTS
                  </Typography>
                  <Typography color="textPrimary" variant="h4">
                    {isLoading ? (
                      <CircularProgress size="1.2rem" color="inherit" />
                    ) : (
                      stats.totalParts
                    )}
                  </Typography>
                </Grid>
                <Grid item>
                  <Avatar
                    sx={{
                      backgroundColor: "success.main",
                      height: 56,
                      width: 56,
                    }}
                  >
                    <ConstructionIcon />
                  </Avatar>
                </Grid>
              </Grid>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "baseline",
                  pt: 2,
                }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    mr: 1,
                  }}
                >
                  {stats.syncedParts}
                </Typography>
                <Typography color="textSecondary" variant="caption">
                  Synced
                </Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>
        <Grid item md={3} xs={12}>
          <Card>
            <CardContent>
              <Grid
                container
                spacing={3}
                sx={{ justifyContent: "space-between" }}
              >
                <Grid item>
                  <Typography
                    color="textSecondary"
                    gutterBottom
                    variant="overline"
                  >
                    TOTAL ORDERS
                  </Typography>
                  <Typography color="textPrimary" variant="h4">
                    {isLoading ? (
                      <CircularProgress size="1.2rem" color="inherit" />
                    ) : (
                      stats.totalOrders
                    )}
                  </Typography>
                </Grid>
                <Grid item>
                  <Avatar
                    sx={{
                      backgroundColor: "success.main",
                      height: 56,
                      width: 56,
                    }}
                  >
                    <ShoppingCartIcon />
                  </Avatar>
                </Grid>
              </Grid>
              <Box
                sx={{
                  alignItems: "center",
                  display: "flex",
                  mt: 2,
                }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    mr: 1,
                  }}
                ></Typography>
                <Typography color="textSecondary" variant="caption">
                  All Type Orders
                </Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>
        <Grid item md={3} xs={12}>
          <AppHealth />
        </Grid>
      </Grid>
      <Box display={dmsSetup?.id ? "block" : "none"} mt={3}>
        <Grid container spacing={3}>
          <Grid item md={6} xs={12}>
            <RecentOrders />
          </Grid>
          <Grid item md={6} xs={12}>
            <RecentLeads />
          </Grid>
          <Grid item xs={12}>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              <Box>
                <Button
                  size="small"
                  color="warning"
                  variant="contained"
                  startIcon={<CalendarMonthIcon />}
                  aria-controls={open ? "date-picker-popover" : undefined}
                  aria-haspopup="true"
                  onClick={(e) => setAnchorEl(e.currentTarget)}
                >
                  {tempFromDate.format("DD-MMM-YYYY") +
                    " to " +
                    tempToDate.format("DD-MMM-YYYY")}
                </Button>
                <Popover
                  id="date-picker-popover"
                  open={open}
                  anchorEl={anchorEl}
                  onClose={handleClose}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  PaperProps={{
                    style: {
                      border: "1px solid #ccc",
                      padding: "16px",
                      borderRadius: "8px",
                    },
                  }}
                >
                  <Box display="flex" flexDirection="column" gap={2}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        label="From Date"
                        value={fromDate}
                        onChange={(newValue) =>
                          setFromDate(newValue ? newValue.startOf("day") : null)
                        }
                        renderInput={(params) => (
                          <TextField {...params} fullWidth variant="standard" />
                        )}
                        maxDate={dayjs()}
                      />
                      <DatePicker
                        label="To Date"
                        value={toDate}
                        onChange={(newValue) =>
                          setToDate(newValue ? newValue.endOf("day") : null)
                        }
                        renderInput={(params) => (
                          <TextField {...params} fullWidth variant="standard" />
                        )}
                        maxDate={dayjs()}
                      />
                    </LocalizationProvider>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => handleApply("applyButton")}
                    >
                      Apply
                    </Button>
                  </Box>
                </Popover>
                <ButtonGroup
                  sx={{ ml: 1.5 }}
                  disableElevation
                  variant="outlined"
                  aria-label="Disabled button group"
                >
                  {presetFilters.map((filter) => (
                    <Button
                      key={filter}
                      color="primary"
                      size="small"
                      variant={
                        selectedPresetFilter === filter
                          ? "contained"
                          : "outlined"
                      }
                      onClick={() => handlePresetFilterChange(filter)}
                    >
                      {filter}
                    </Button>
                  ))}
                </ButtonGroup>
                <Tooltip title="You can drag these cards!" placement="right">
                  <IconButton size="large" color="info">
                    <InfoOutlinedIcon />
                  </IconButton>
                </Tooltip>
              </Box>
              <Box>
                <Link
                  href={`https://admin.shopify.com/store/${handleGetShopifyURL(
                    dmsSetup?.shopifyUrl ?? ""
                  )}/dashboards`}
                  variant="body2"
                  target="_blank"
                >
                  View Shopify Analytics
                </Link>
              </Box>
            </Box>
          </Grid>
          <DragDropContext onDragEnd={onDragEnd} onDragStart={onDragStart}>
            {positions.map((widgetId, index) => {
              const widget = getWidgetById(widgetId);
              if (!widget) return null;

              const Component = widget.component;
              return (
                <Droppable droppableId={`dropZone-${widgetId}`} key={widgetId}>
                  {(provided, snapshot) => (
                    <Grid item md={6} xs={12}>
                      <div
                        style={getListStyle(snapshot.isDraggingOver)}
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                      >
                        <Draggable
                          draggableId={`${widgetId}`}
                          index={index}
                          key={widgetId}
                        >
                          {(provided, snapshot) => (
                            <div
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              ref={provided.innerRef}
                              style={getItemStyle(
                                snapshot.isDragging,
                                provided.draggableProps.style
                              )}
                            >
                              <Component {...widget.props} />
                            </div>
                          )}
                        </Draggable>
                        {provided.placeholder}
                      </div>
                    </Grid>
                  )}
                </Droppable>
              );
            })}
          </DragDropContext>
        </Grid>
      </Box>
    </>
  );
};

const generateDateChunks = (
  startDate: string,
  endDate: string,
  rangeType: "minutes" | "hours" | "days" | "weeks" | "months" | "years",
  rangeValue: number,
  formatType: "datetime" | "date"
) => {
  const dateArray = [];
  const utcStartDate = startDate.endsWith("Z") ? startDate : `${startDate}Z`;
  const dateStart = dayjs(utcStartDate);
  const utcEndDate = endDate.endsWith("Z") ? endDate : `${endDate}Z`;
  const dateEnd = dayjs(utcEndDate);

  const dateFormat =
    formatType === "datetime" ? "YYYY-MM-DD HH:mm:ss" : "YYYY-MM-DD";

  let currentDate = dateStart;
  dateArray.push(currentDate.format(dateFormat));

  while (currentDate.add(rangeValue, rangeType).isBefore(dateEnd)) {
    currentDate = currentDate.add(rangeValue, rangeType);
    dateArray.push(currentDate.format(dateFormat));
  }

  if (!dateArray.includes(dateEnd.format(dateFormat))) {
    dateArray.push(dateEnd.format(dateFormat));
  }

  return dateArray;
};

const countOrdersInDateRange = (orders: any[], dateRange: any[]) => {
  const orderCounts = [];
  for (let i = 0; i < dateRange.length; i++) {
    const startDate = dayjs(dateRange[i]);
    const endDate = dayjs(dateRange[i + 1]);
    const count = orders.filter((order: any) => {
      const utcOrderDate = order.date.endsWith("Z")
        ? order.date
        : `${order.date}Z`;
      const orderDate = new Date(utcOrderDate);
      const localOrderDate = dayjs(orderDate.toLocaleString());
      return localOrderDate >= startDate && localOrderDate < endDate;
    }).length;
    orderCounts.push(count);
  }
  return orderCounts;
};

const sumOrderAmountsInDateRange = (orders: any[], dateRange: any[]) => {
  const orderAmounts = [];
  for (let i = 0; i < dateRange.length; i++) {
    const startDate = dayjs(dateRange[i]);
    const endDate = dayjs(dateRange[i + 1]);
    const totalAmount = orders.reduce((sum, order) => {
      const utcOrderDate = order.date.endsWith("Z")
        ? order.date
        : `${order.date}Z`;
      const orderDate = new Date(utcOrderDate);
      const localOrderDate = dayjs(orderDate.toLocaleString());
      if (localOrderDate >= startDate && localOrderDate < endDate) {
        return sum + order.amount;
      }
      return sum;
    }, 0);
    orderAmounts.push(totalAmount);
  }
  return orderAmounts;
};

const averageOrderAmountsInDateRange = (orders: any[], dateRange: any[]) => {
  const averageAmounts = [];

  for (let i = 0; i < dateRange.length; i++) {
    const startDate = dayjs(dateRange[i]);
    const endDate = dayjs(dateRange[i + 1]);

    const { totalAmount, orderCount } = orders.reduce(
      (acc, order) => {
        const utcOrderDate = order.date.endsWith("Z")
          ? order.date
          : `${order.date}Z`;
        const orderDate = new Date(utcOrderDate);
        const localOrderDate = dayjs(orderDate.toLocaleString());
        if (localOrderDate >= startDate && localOrderDate < endDate) {
          acc.totalAmount += order.amount;
          acc.orderCount += 1;
        }
        return acc;
      },
      { totalAmount: 0, orderCount: 0 }
    );

    const averageAmount = orderCount > 0 ? totalAmount / orderCount : 0;
    averageAmounts.push(averageAmount);
  }

  return averageAmounts;
};
